import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'

import classes from './why-smarty.module.scss'
import Addons from '../../static/images/addons.svg'
import Checkmark from '../../static/images/checkmark.svg'
import NoContract from '../../static/images/noContracts.svg'
import { ThreeColumn } from '../shared'

interface WhySmartyPlansProps {
  darkTheme?: boolean
}

const cards = [
  {
    src: NoContract,
    alt: '',
    titleTestId: 'one-month-plan-title',
    cardTestId: 'one-month-plan-card',
    iconTestId: 'one-month-plan-icon',
    textTestId: 'one-month-plan-text',
    title: '1 month plans',
    text: 'Cancel or change plans anytime. No contracts, no credit checks and no surprises at the end of the month. Pay in advance and enjoy the flexibility.',
  },
  {
    src: Checkmark,
    alt: '',
    titleTestId: 'keep-your-number-title',
    cardTestId: 'keep-your-number-card',
    iconTestId: 'keep-your-number-icon',
    textTestId: 'keep-your-number-text',
    title: 'Keep your number',
    text: "Simply text 'PAC' to 65075 to get a code valid for 1 month. We'll walk you through steps to enter this code to transfer the phone number you want to keep.",
  },
  {
    src: Addons,
    alt: '',
    titleTestId: 'tether-without-worring-title',
    cardTestId: 'tether-without-worring-card',
    iconTestId: 'tether-without-worring-icon',
    textTestId: 'tether-without-worring-text',
    title: 'Tether without worrying',
    text: "You can tether and hot-spot all of your data with no speed caps as long as you're in the UK.",
  },
]

export const WhySmartyPlans: FC<WhySmartyPlansProps> = ({ darkTheme }) => (
  <section>
    <ThreeColumn>
      {cards.map((card) => (
        <div
          key={card.title}
          className={classes.whyCard}
          data-testid={card.cardTestId}
        >
          <img
            src={card.src}
            alt={card.alt}
            width="64"
            height="64"
            data-testid={card.iconTestId}
          />
          <Typography
            component="h3"
            variant="Kollektif/MediumEmphasis"
            className={classes.whyCardTitle}
            data-testid={card.titleTestId}
          >
            {card.title}
          </Typography>
          <Typography
            variant="Kollektif/Small"
            dataTestId={card.textTestId}
            className={darkTheme ? classes.darkText : undefined}
          >
            {card.text}
          </Typography>
        </div>
      ))}
    </ThreeColumn>
  </section>
)

export default WhySmartyPlans
